<form autocomplete="off" class="p-0" novalidate enctype="multipart/form-data" [formGroup]="qualificationDetailsForm">
    <div class="col-lg-12 col-md-12">
        <!-- <div class="card custom-card "> -->
        <div class="mt-3">
            <div>
                <h3 class="main-content-label mb-2"><b>
                    <img alt="Logo" width="20vh" src="../../assets/images/knowledge.png"
                    class="mh-45px mrl mt-1 pb-2">
                        Qualification Details</b></h3>
            </div>

            <div class="row clearfix">

                <div class="col-sm-3">
                    <!-- *ngIf="qualificationDetailsFormArray['StuCoLvl'][0]['FormVisible']" -->
                    <div class="form-group">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>
                          {{qualificationDetailsFormArray['StuCoLvl'][0]['FormDisplayName']}}
                          <span *ngIf="qualificationDetailsFormArray['StuCoLvl'][0]['FormRequired']">*</span>
                        </mat-label>
                        <mat-select 
                          #select10441
                          class="colorblack" 
                          formControlName="StuCoLvl" 
                             (selectionChange)="fetchCourseForQual($event)">
                          <!-- //  (selectionChange)="fetchCourseForQual($event)">searchCourseQualification // -->
                          <mat-select-filter 
                            *ngIf="select10441.focused" 
                            [placeholder]="'Filter'" 
                            [displayMember]="'CdDesc'" 
                            [array]="courseLevelList"
                            (filteredReturn)="filteredcourseLevelList = $event">
                          </mat-select-filter>
                          <mat-option 
                            *ngFor="let item of filteredcourseLevelList" 
                            [value]="item.CdCode">
                            {{item.CdDesc}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                          *ngIf="qualificationDetailsForm.controls['StuCoLvl'].touched && qualificationDetailsForm.controls['StuCoLvl'].errors?.required">
                          Mandatory
                        </mat-error>
                        <mat-error class="margin_tp"
                            *ngIf="qualificationDetailsForm.controls['StuCoLvl'].touched 
                            && qualificationDetailsForm.controls['StuCoLvl'].hasError('sameLevel')">
                            Selected course level already exists.
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  
                  <div class="col-sm-3" *ngIf="qualificationDetailsFormArray['StuCoName'][0]['FormVisible']">
                    <div class="form-group">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>
                          {{qualificationDetailsFormArray['StuCoName'][0]['FormDisplayName']}}
                          <span *ngIf="qualificationDetailsFormArray['StuCoName'][0]['FormRequired']">*</span>
                        </mat-label>
                        <mat-select 
                          #select10442
                          class="colorblack" 
                          formControlName="StuCoName">
                          <mat-select-filter 
                            *ngIf="select10442.focused" 
                            [placeholder]="'Filter'" 
                            [displayMember]="'CdDesc'" 
                            [array]="filteredcourseList"
                            (filteredReturn)="filteredcourseList = $event">
                          </mat-select-filter>
                          <mat-option 
                            *ngFor="let item of filteredcourseList" 
                            [value]="item.CdCode">
                            {{item.CdDesc}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                          *ngIf="qualificationDetailsForm.controls['StuCoName'].touched && qualificationDetailsForm.controls['StuCoName'].errors?.required">
                          Mandatory
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                <div class="col-sm-3" *ngIf="qualificationDetailsFormArray['StuQualStr'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{qualificationDetailsFormArray['StuQualStr'][0]['FormDisplayName']}}
                                <span *ngIf="qualificationDetailsFormArray['StuQualStr'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select [disabled]="delReadOnly" formControlName="StuQualStr"
                                #select104 placeholder="Status"
                                class="colorblack">
                                <!-- <mat-option>Select</mat-option> (click)="onSelectionChangedForDecResu(1)"-->
                                <mat-option [value]="1">Declared</mat-option>
                                <!-- <mat-option [value]="2"  (click)="onSelectionChangedForDecResu(2)">Not Declared</mat-option> -->
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="qualificationDetailsForm.controls['StuQualStr'].touched && qualificationDetailsForm.controls['StuQualStr'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>

                    </div>
                </div>
                <div class="col-sm-3" *ngIf="qualificationDetailsFormArray['StuUniversity'][0]['FormVisible'] && !showotheruni && this.CourseType !== 'phd'">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{qualificationDetailsFormArray['StuUniversity'][0]['FormDisplayName']}}
                                <span *ngIf="qualificationDetailsFormArray['StuUniversity'][0]['FormRequired']">*</span>
                            </mat-label>
                            <!-- <mat-select [disabled]="delReadOnly" formControlName="StuUniversity" #select104
                                placeholder="Caste" class="colorblack">
                                <mat-option>Select</mat-option>
                                <mat-option value="1">Shivaji University</mat-option>
                                <mat-option value="2">Pune University</mat-option>
                                <mat-option value="3">KLE University</mat-option>
                            </mat-select> -->
                            <mat-select  #select1054
                            class="colorblack" formControlName="StuUniversity">
                            <mat-select-filter *ngIf="select1054.focused" [placeholder]="'Filter'"
                                [displayMember]="'CdDesc'" [array]="boardUniList"
                                (filteredReturn)="filteredboardUniList =$event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredboardUniList" [value]="item.CdCode" (click)="otherUniversity(item)">
                                {{item.CdDesc}}
                            </mat-option>
                        </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="qualificationDetailsForm.controls['StuUniversity'].touched && qualificationDetailsForm.controls['StuUniversity'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>

                    </div>
                </div>

                <div class="col-sm-4" *ngIf="showotheruni">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>
                                    Board/University Name
                                </mat-label>
                                <input [readonly]="delReadOnly" maxlength="500" formControlName="otherUni" matInput
                                    placeholder="Name">
                                <!-- <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuClgName'].touched && qualificationDetailsForm.controls['StuClgName'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuClgName'].touched && qualificationDetailsForm.controls['StuClgName'].errors?.pattern">
                                    Invalid
                                </mat-error> -->
                            </mat-form-field>

                        </div>
                    </div>
                </div>

                <div class="col-sm-4" *ngIf="qualificationDetailsFormArray['StuClgName'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuClgName'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="qualificationDetailsFormArray['StuClgName'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" maxlength="500" formControlName="StuClgName" matInput
                                    [placeholder]="qualificationDetailsFormArray['StuClgName'][0]['FormDisplayName']">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuClgName'].touched && qualificationDetailsForm.controls['StuClgName'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuClgName'].touched && qualificationDetailsForm.controls['StuClgName'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuPassYr'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuPassYr'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuPassYr'][0]['FormRequired']">*</span>
                                </mat-label>
                                <!-- <mat-select [disabled]="delReadOnly" formControlName="StuPassYr" #select104
                                    placeholder="Year" class="colorblack">
                                    <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
                                </mat-select> -->
                                <!-- <mat-select  #select1044 
                                class="colorblack" formControlName="StuPassYr">
                                <mat-select-filter *ngIf="select1044.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdDesc'" [array]="PassYearList"
                                    (filteredReturn)="filteredPassYearList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredPassYearList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select> -->
                              <mat-select #select1044 formControlName="StuPassYr">
                                <mat-select-filter *ngIf="select1044.focused" [placeholder]="'Filter'"
                                  [displayMember]="'description'"  
                                  [array]="PassYearList"
                                  (filteredReturn)="filteredPassYearList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let year of filteredPassYearList" [value]="year.year">
                                  {{ year.year }} 
                                </mat-option>
                              </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuPassYr'].touched && qualificationDetailsForm.controls['StuPassYr'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuMarkListRgNo'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuMarkListRgNo'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="qualificationDetailsFormArray['StuMarkListRgNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <!-- [readonly]="delReadOnly || resultNotDec"  -->
                                <input formControlName="StuMarkListRgNo" matInput
                                    [placeholder]="qualificationDetailsFormArray['StuMarkListRgNo'][0]['FormDisplayName']" maxlength="20" [readonly]="delReadOnly">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarkListRgNo'].touched && qualificationDetailsForm.controls['StuMarkListRgNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarkListRgNo'].touched && qualificationDetailsForm.controls['StuMarkListRgNo'].errors?.pattern">
                                    Enter Valid Data.
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuSeatNo'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuSeatNo'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuSeatNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuSeatNo" matInput
                                    [placeholder]="qualificationDetailsFormArray['StuSeatNo'][0]['FormDisplayName']" maxlength="20">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuSeatNo'].touched && qualificationDetailsForm.controls['StuSeatNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuSeatNo'].touched && qualificationDetailsForm.controls['StuSeatNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuMarksTot'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuMarksTot'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="qualificationDetailsFormArray['StuMarksTot'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly"  formControlName="StuMarksTot" matInput
                                    placeholder="Marks" maxlength="5" (change)="percentage()">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarksTot'].touched && qualificationDetailsForm.controls['StuMarksTot'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarksTot'].touched && qualificationDetailsForm.controls['StuMarksTot'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuMarksObt'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuMarksObt'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="qualificationDetailsFormArray['StuMarksObt'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuMarksObt" matInput
                                    placeholder="Marks" maxlength="5" (change)="percentage()">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarksObt'].touched && qualificationDetailsForm.controls['StuMarksObt'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarksObt'].touched && qualificationDetailsForm.controls['StuMarksObt'].errors?.pattern">
                                    Invalid
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarksObt'].hasError('greaterThanTotal')">
                                    Obtained marks cannot be greater than total marks
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>

                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuPercent'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuPercent'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="qualificationDetailsFormArray['StuPercent'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input  formControlName="StuPercent" maxlength="5" matInput [placeholder]="qualificationDetailsFormArray['StuPercent'][0]['FormDisplayName']">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuPercent'].touched && qualificationDetailsForm.controls['StuPercent'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuPercent'].touched && qualificationDetailsForm.controls['StuPercent'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuGrade'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuGrade'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuGrade'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select [disabled]="delReadOnly" formControlName="StuGrade" #select104
                                    class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option value="1">A</mat-option>
                                    <mat-option value="2">A+</mat-option>
                                    <mat-option value="3">B</mat-option>
                                    <mat-option value="4">B+</mat-option>
                                    <mat-option value="5">C</mat-option>
                                    <mat-option value="6">D</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuGrade'].touched && qualificationDetailsForm.controls['StuGrade'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuCgpi'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuCgpi'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuCgpi'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuCgpi" matInput [placeholder]="qualificationDetailsFormArray['StuCgpi'][0]['FormDisplayName']"
                                    maxlength="3">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuCgpi'].touched && qualificationDetailsForm.controls['StuCgpi'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuCgpi'].touched && qualificationDetailsForm.controls['StuCgpi'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <!-- <div class="col-sm-4"></div> -->
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuClass'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{qualificationDetailsFormArray['StuClass'][0]['FormDisplayName']}}
                                <span *ngIf="qualificationDetailsFormArray['StuClass'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select [disabled]="delReadOnly" formControlName="StuClass" #select104
                                placeholder="Type" class="colorblack">
                                <mat-option>Select</mat-option>
                                <mat-option value="1">Distinction</mat-option>
                                <mat-option value="2">First Class</mat-option>
                                <mat-option value="3">Second Class</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="qualificationDetailsForm.controls['StuClass'].touched && qualificationDetailsForm.controls['StuClass'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>

                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuPlace'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuPlace'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuPlace'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuPlace" matInput [placeholder]="qualificationDetailsFormArray['StuPlace'][0]['FormDisplayName']"
                                    maxlength="100">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuPlace'].touched && qualificationDetailsForm.controls['StuPlace'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuPlace'].touched && qualificationDetailsForm.controls['StuPlace'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>


                <div class="col-sm-2" *ngIf="showMigrationField" >
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['StuMigrationNo'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuMigrationNo'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuMigrationNo" matInput [placeholder]="qualificationDetailsFormArray['StuMigrationNo'][0]['FormDisplayName']"
                                    maxlength="20">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMigrationNo'].touched && qualificationDetailsForm.controls['StuMigrationNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMigrationNo'].touched && qualificationDetailsForm.controls['StuMigrationNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>

                <div class="col-sm-2" *ngIf="showNeet">
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['StuNeetRgNo'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuNeetRgNo'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuNeetRgNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuNeetRgNo" matInput [placeholder]="qualificationDetailsFormArray['StuNeetRgNo'][0]['FormDisplayName']"
                                    maxlength="20">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuNeetRgNo'].touched && qualificationDetailsForm.controls['StuNeetRgNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuNeetRgNo'].touched && qualificationDetailsForm.controls['StuNeetRgNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="showNeet">
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['StuNeetRollNo'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuNeetRollNo'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuNeetRollNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuNeetRollNo" matInput [placeholder]="qualificationDetailsFormArray['StuNeetRollNo'][0]['FormDisplayName']"
                                    maxlength="20">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuNeetRollNo'].touched && qualificationDetailsForm.controls['StuNeetRollNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuNeetRollNo'].touched && qualificationDetailsForm.controls['StuNeetRollNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="showNeet">
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['StuNeetMarksObt'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuNeetMarksObt'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuNeetMarksObt'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuNeetMarksObt" matInput [placeholder]="qualificationDetailsFormArray['StuNeetMarksObt'][0]['FormDisplayName']"
                                    maxlength="15">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuNeetMarksObt'].touched && qualificationDetailsForm.controls['StuNeetMarksObt'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuNeetMarksObt'].touched && qualificationDetailsForm.controls['StuNeetMarksObt'].errors?.max">
                                    Maximum allowed marks is 720
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuNeetMarksObt'].touched && qualificationDetailsForm.controls['StuNeetMarksObt'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="showNeet">
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['StuNeetMarksTot'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuNeetMarksTot'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuNeetMarksTot'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuNeetMarksTot" matInput [placeholder]="qualificationDetailsFormArray['StuNeetMarksTot'][0]['FormDisplayName']"
                                    maxlength="15">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuNeetMarksTot'].touched && qualificationDetailsForm.controls['StuNeetMarksTot'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuNeetMarksTot'].touched && qualificationDetailsForm.controls['StuNeetMarksTot'].errors?.max">
                                    Maximum allowed marks is 720
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuNeetMarksTot'].touched && qualificationDetailsForm.controls['StuNeetMarksTot'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                
                <div class="col-sm-2" *ngIf="showCEE">
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['CEEAppNo'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['CEEAppNo'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['CEEAppNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="CEEAppNo" matInput [placeholder]="qualificationDetailsFormArray['CEEAppNo'][0]['FormDisplayName']"
                                    maxlength="20">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['CEEAppNo'].touched && qualificationDetailsForm.controls['CEEAppNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['CEEAppNo'].touched && qualificationDetailsForm.controls['CEEAppNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="showPhD">
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['StuEntranceRollNo'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuEntranceRollNo'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuEntranceRollNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuEntranceRollNo" matInput [placeholder]="qualificationDetailsFormArray['StuEntranceRollNo'][0]['FormDisplayName']"
                                    maxlength="20">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuEntranceRollNo'].touched && qualificationDetailsForm.controls['StuEntranceRollNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuEntranceRollNo'].touched && qualificationDetailsForm.controls['StuEntranceRollNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="showPhD">
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['StuEntranceEntrollNo'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuEntranceEntrollNo'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuEntranceEntrollNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuEntranceEntrollNo" matInput [placeholder]="qualificationDetailsFormArray['StuEntranceEntrollNo'][0]['FormDisplayName']"
                                    maxlength="20">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuEntranceEntrollNo'].touched && qualificationDetailsForm.controls['StuEntranceEntrollNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuEntranceEntrollNo'].touched && qualificationDetailsForm.controls['StuEntranceEntrollNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="showCEE">
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['CEERollNo'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['CEERollNo'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['CEERollNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="CEERollNo" matInput [placeholder]="qualificationDetailsFormArray['CEERollNo'][0]['FormDisplayName']"
                                    maxlength="20">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['CEERollNo'].touched && qualificationDetailsForm.controls['CEERollNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['CEERollNo'].touched && qualificationDetailsForm.controls['CEERollNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="showCEE">
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['StuCEEMarksObt'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuCEEMarksObt'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuCEEMarksObt'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuCEEMarksObt" matInput [placeholder]="qualificationDetailsFormArray['StuCEEMarksObt'][0]['FormDisplayName']"
                                    maxlength="14">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuCEEMarksObt'].touched && qualificationDetailsForm.controls['StuCEEMarksObt'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuCEEMarksObt'].touched && qualificationDetailsForm.controls['StuCEEMarksObt'].errors?.max">
                                    Maximum allowed marks is 100
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuCEEMarksObt'].touched && qualificationDetailsForm.controls['StuCEEMarksObt'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="showCEE">
                    <div class="form-group" *ngIf="qualificationDetailsFormArray['StuCEEMarksTot'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuCEEMarksTot'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuCEEMarksTot'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuCEEMarksTot" matInput [placeholder]="qualificationDetailsFormArray['StuCEEMarksTot'][0]['FormDisplayName']"
                                    maxlength="14">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuCEEMarksTot'].touched && qualificationDetailsForm.controls['StuCEEMarksTot'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuCEEMarksTot'].touched && qualificationDetailsForm.controls['StuCEEMarksTot'].errors?.max">
                                    Maximum allowed marks is 100
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuCEEMarksTot'].touched && qualificationDetailsForm.controls['StuCEEMarksTot'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
 <span class="update-section" *ngIf="qualificationDetailsForm.get('StuCoLvl')?.value == 8">
                            <span class="d-inline-flex align-items-center">
                                <label class="fw-bold d-block">
                                    Have you qualified UGC-NET (including JRF) / UGC-CSIR NET (including JRF) / SLET / GATE / Teacher Fellowship holder?  
                                </label>
                                <mat-radio-group formControlName="Marksheet" class="d-flex align-items-center">
                                    <mat-radio-button value="Y" class="me-2">
                                        Yes
                                    </mat-radio-button>
                                    <mat-radio-button value="N">
                                        No
                                    </mat-radio-button>
                                </mat-radio-group>
                            </span>
                        </span>
                <div class="col-sm-12 btnpossition"
                *ngIf="qualificationDetailsFormArray['fileUploadData'][0]['FormVisible']">
                <div class="form-group">
                    <div class="col-sm-6">
                        <mat-label>{{qualificationDetailsForm.get('StuCoLvl')?.value == 7
                        ? qualificationDetailsFormArray['fileUploadData1'][0]['FormDisplayName']
                        : qualificationDetailsFormArray['fileUploadData'][0]['FormDisplayName']}}
                            <span
                                *ngIf="qualificationDetailsFormArray['fileUploadData'][0]['FormRequired']">*</span>
                        </mat-label>
                    </div>
                    <input #fileUploader type="file" formControlName="fileUploadData" (change)="onChange($event)" *ngIf="!hideFileInput"/>
                   
                      <div *ngIf="filename; else noFileUploaded" (click)="showbaseFile()">
                        <p class="file-name">
                            Uploaded File: <span class="blue_col">{{ filename }}</span>
                        </p>
                    </div>
                    <ng-template #noFileUploaded>
                        <p *ngIf="!filename && prepopulateDataAvailable">File Not Uploaded</p>
                    </ng-template>
                    <mat-error class="margin_tp"
                    *ngIf="qualificationDetailsForm.controls['fileUploadData'].touched && qualificationDetailsForm.controls['fileUploadData'].errors?.required">
                    Mandatory
                </mat-error>
                </div>
               
            </div>
                <!-- this is temp commented -->
                <!-- <div *ngIf='uploadedFile' class="col-sm-12 ">
                    <div  class="col-sm-6" *ngFor="let data of qualList; let i = index"  (click)='showUploadedFile(data)'   class="text-center">
                       <a><label class="blue_col1 ">uploaded File</label></a>
                </div>
                </div> -->
                <div class="col-sm-12">
                    <div class="form-group redCol">
                        <h6 class="mb-1 redCol"><b>
                                Note 1: Please upload file less than 3 MB. Please upload
                                only png, jpg, jpeg or pdf file.</b></h6>
                        <h6 class="mb-1 redCol"><b>
                                Note 2: Kindly enter correct obtained marks, total marks and percentage as per
                                marksheet,
                                merit will be generated on the basis of percentage.</b></h6>
                        <h6 class="mb-1 redCol"><b>
                                Note 3: In case student have multiple marksheet then zip it and upload it year wise.</b>
                        </h6>
                        <h6 class="mb-1 redCol"><b>
                                Note 4: Filling all the classes is mandatory.</b>
                        </h6>
                        <!-- <div class="checkbox-container" *ngIf="nextButton">
                            <mat-checkbox onkeydown="return (event.keyCode!=13);" formControlName="CheckNote" (change)="getCheck($event)">
                            </mat-checkbox>
                            <span class="checkbox-text">
                              <b>"I agree that eligibility for participation is subject to detailed scrutiny and verification. <br>
                              I understand that all submitted information and documentation will be reviewed for compliance with applicable rules, regulations, and criteria. <br>
                              I acknowledge that the final determination of eligibility rests with the authorized governing body and may be subject to revision or revocation based on findings during or after the review process."
                            </b>
                            </span><br>
                           
                          </div>
                          <h6 class="mb-1 redColor" *ngIf="nextButton && !qualificationDetailsForm.get('CheckNote')?.value">
                            To go on next tab please agree the above terms and conditions.
                        </h6> -->
                        
                    </div>
                </div>
                <div class="row mb-2 prpl">
                    <div class="col-sm-12">
                        <button type="button" *ngIf="submitButton" [disabled]="isSaving || disabled"
                            (click)="SubmitQualificationDetails()"
                            class="btn btn-primary btn-icon-text floatright sz fr mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" *ngIf="updateButton" [disabled]="disabled"
                            (click)="UpdateQualificationDetails()"
                            class="btn btn-primary btn-icon-text floatright sz fr mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/edit.gif" style="margin-right: 5px;">
                                Update
                            </span>
                        </button>
                         <span class="update-section" *ngIf="updateButton">
                            <span *ngIf="showUpdateRadio" class="d-inline-flex align-items-center">
                                <label class="fw-bold d-block">
                                    Save & Proceed For Scrutiny!
                                </label>
                                <mat-radio-group formControlName="updateAllQualification" class="d-flex align-items-center">
                                    <mat-radio-button value="Y" class="me-2">
                                        Yes
                                    </mat-radio-button>
                                    <mat-radio-button value="N">
                                        No
                                    </mat-radio-button>
                                </mat-radio-group>
                            </span>
                        </span>
                        <button type="button" *ngIf="deleteButton" [disabled]="disabled"
                            (click)="openConformationModalBox()" class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/trash.gif" style="margin-right: 5px;">
                                Delete
                            </span>
                        </button>
                        <button type="button" *ngIf="resetButton" [disabled]="disabled" (click)="resetForm()"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/add-file.gif" style="margin-right: 5px;">
                                New
                            </span>
                        </button>
                        
                        <button type="button" *ngIf="nextButton" (click)="nextTab()"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1" >
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/turn-right.gif" style="margin-right: 5px;">
                                Next
                            </span>
                        </button>
                        <button type="button" (click)="back()" class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/turn-left.gif" style="margin-right: 5px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>
                <hr *ngIf="isDivShow==true">
                <div *ngIf="isDivShow==true" class="table-responsive" id="table">
                    <table id="datatable" class="table table-bordered text-nowrap">
                        <thead>
                            <tr  class="text-left">

                                <th class="f600">
                                    No.
                                </th>
                                <th class="f600 text-left" *ngIf="CourseType !== 'phd'" >
                                    Board / University
                                </th>
                                <th class="f600">
                                    School/College/University
                                </th>
                                <th class="f600">
                                    Course Level
                                </th>
                                <th class="f600">
                                    Pass Year
                                </th>
                                <th *ngIf="hasNeetRollNo" width="7%">
                                   NEET Roll No.
                                </th>
                                <th *ngIf="hasNeetAppNo" width="7%">
                                    NEET Application No.
                                </th>
                                <th *ngIf="hasNeetMarksObt" width="7%">
                                    NEET Marks Obtained
                                </th>
                                <th *ngIf="hasNeetMarksTot" width="7%">
                                    NEET Total Marks
                                </th>
                                <th *ngIf="hasCeeRollNo" width="7%">
                                   CEE Roll Number
                                </th>
                                <th *ngIf="hasCeeAppNo" width="7%">
                                    CEE Application Number
                                </th>
                                <th *ngIf="hasCeeMarksObt" width="7%">
                                    CEE Marks Obtained
                                </th>
                                <th *ngIf="hasCeeMarksTot" width="7%">
                                    CEE Total Marks
                                </th>
                                <th *ngIf="hasEntranceRollNo" width="7%">
                                   PhD Entrance Exam Roll Number
                                </th>
                                <th *ngIf="hasEntranceEntrollNo" width="7%">
                                    PhD Entrance Exam Enrollment Number
                                </th>
                                <th width="7%">
                                    Percent
                                </th>
                                <th width="7%">
                                    Document
                                </th>
                                <th width="5%">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody id="table_data">
                            <tr *ngFor="let data of qualList; let i = index" class="text-left">

                                <td>
                                    {{i + 1}}
                                </td>
                                <td *ngIf="CourseType !== 'phd'">
                                   {{data.CdDesc}}
                                </td>
                                
                                <td >
                                    {{data.StuClgName}}
                                </td>

                                <td>
                                    {{data.StuCourseLevel}}
                                </td>
                                <td >
                                    {{data.StuPassYr}}
                                </td>
                                <td *ngIf="hasNeetRollNo">
                                    {{data.StuNeetRollNo}}
                                </td>
                                <td *ngIf="hasNeetAppNo">
                                    {{data.StuNeetRgNo}}
                                </td>
                                <td *ngIf="hasNeetMarksObt">
                                    {{data.StuNeetMarksObt}}
                                </td>
                                <td *ngIf="hasNeetMarksTot">
                                    {{data.StuNeetMarksTot}}
                                </td>
                                <td *ngIf="hasCeeRollNo">
                                    {{data.CEERollNo}}
                                </td>
                                <td *ngIf="hasCeeAppNo">
                                    {{data.CEEAppNo}}
                                </td>
                                <td *ngIf="hasCeeMarksObt">
                                    {{data.StuCEEMarksObt}}
                                </td>
                                <td *ngIf="hasCeeMarksTot">
                                    {{data.StuCEEMarksTot}}
                                </td>
                                 <td *ngIf="hasEntranceRollNo">
                                    {{data.StuEntranceRollNo}}
                                </td>
                                <td *ngIf="hasEntranceEntrollNo">
                                    {{data.StuEntranceEntrollNo}}
                                </td>
                                <td >
                                    {{data.StuPercent}}
                                </td>
                                <td class="text-center">
                                    <!-- <img src="{{data.fileUploadData}}"> -->
                                    <!-- <a>
                                        <label class="blue_col">{{data.fileUploadData}}</label></a> -->
        
                                    <a *ngIf="data.isViewable" (click)="showbase64(data)">
                                        <label class="blue_col">View</label></a>
                                         <label *ngIf="!data.isViewable">No document uploaded</label>
                                </td>
                                <td class="text-center">
                                    <a class="btn-floating" (click)="onselectPrepopulate(data)" title="Prepopulate">
                                        <i class="fa fa-eye" aria-hidden="false"></i>
                                    </a>
                                    <a class="btn-floating" title="Delete" (click)="onselectPrepopulateForDelete(data)">
                                        <i class="fas fa-trash"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

        </div>
        <!-- </div> -->
    </div>
</form>